import { Component, OnInit } from "@angular/core";
import { Title, Meta } from "@angular/platform-browser";
// import { fadeInAnimation } from '../animation/animation.component';
import { Router, ActivatedRoute } from "@angular/router";
import { HomeService } from "./home.service";
import { BACKEND_API_URL } from "../core/services/CusHttp";
import { AdService } from "../core/services/ad.service";

export interface CommonCache {
  expire: number;
  data: any;
}

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  providers: [HomeService]
  // animations: [fadeInAnimation],
  // 附加淡入动画到组件的最外层元素上
  // host: { '[@fadeInAnimation]': '' }
})
export class HomeComponent implements OnInit {
  public jobsList: Array<any> = []; //岗位列表
  public sort: string = "newest"; //默认请求最新岗位信息
  public tabShow: number = 1;
  public paramsData: any = {}; //岗位帅选条件
  public typeCooper: string = "0"; //0合作企业 1合作高校 不传显示两者
  public typeCooperList: any = []; //0合作企业 1合作高校 不传显示两者
  public imgUrl: string = BACKEND_API_URL;
  adDatas: any = {}; //首页广告
  public newestList: CommonCache;
  public hotList: CommonCache;
  constructor(
    public _homeService: HomeService,
    public _router: Router,
    public _adService: AdService,
    private _title: Title,
    private _meta: Meta
  ) {
    this._title.setTitle("X直聘-北京博导前程");
    this._meta.updateTag({
      name: "Keywords",
      content: "X直聘_大学生实习_实习报告_个人简历模板_实习报告怎么写"
    });
    this._meta.updateTag({
      name: "Description",
      content: `X直聘为大学实习生提供全方位的就业支持。通过职业评测，在线课程，实训实战任务，电商大赛等方式提高大学生能力，获得相应的技能勋章，完成能力认证。同时帮助大学实习生做好:职业规划、个人简历制作，实习报告、实习心得等等，服务于职场新人，提升综合就业能力`
    });
  }

  ngOnInit() {
    //获取广告图片
    this._adService.getAdInfo("home_banner").then(data => {
      this.adDatas = data["data"];
    });

    this.getJobList();

    this.getCooperData(); //获取合作企业高校
  }

  //点击轮播广告
  jumpad(row) {
    this._adService.jumpId(row.id).then(res => {
    });
  }

  //最新岗位 和热门岗位切换
  changeJobType(event) {
    if (this.sort !== event) {
      this.sort = event;
      this.getCacheData(); //获取缓存数据
    }
  }
  //获取缓存数据
  getCacheData() {
    switch (this.sort) {
      case "newest":
        if (this.newestList && this.newestList.expire > new Date().getTime()) {
          this.jobsList = this.newestList.data;
        } else {
          this.getJobList(); //调用岗位列表接口
        }
        break;
      case "hot":
        if (this.hotList && this.hotList.expire > new Date().getTime()) {
          this.jobsList = this.hotList.data;
        } else {
          this.getJobList(); //调用岗位列表接口
        }
        break;
    }
  }

  getJobList() {
    this._homeService.getJobsList(this.sort).then(resp => {
      //获取岗位信息
      if (resp.success) {
        //请求成功后赋值给  jobsList

        let expire = new Date().getTime() + 5000;
        this.sort === "newest"
          ? (this.newestList = { expire: expire, data: resp["data"] })
          : (this.hotList = { expire: expire, data: resp["data"] });
        this.jobsList = resp["data"];
        this.jobsList.map(row => {
          row.welfare == ""
            ? (row.welfare = null)
            : (row.welfare = row.welfare.split(",")); //福利数据处理
          // if (row.welfare) { row.welfare.splice(row.welfare.findIndex(rec => rec === ''), 1); }
        });
      } else {
        // alert(resp['msg']);  //错误提示信息
      }
    });
  }
  //获取选中岗位的id
  getJobId($event) {
    // console.log("JobId:", $event);
    this._router.navigate(["/job//detail/", $event]);
  }
  //获取选中公司的id
  getCompanyId($event) {
    // console.log("CompanyId:", $event);
    this._router.navigate(["/job/company/", $event]);
  }
  //获取选中行业的id
  getCateId(event) {
    // console.log("cate:", event);
    this.paramsData.position_industry_cid = event["position_industry_cid"];
    this.paramsData.position_industry_pid = event["position_industry_pid"];
    this._router.navigate(["/job/"], { queryParams: this.paramsData });
    // {queryParams:this.locationBack}
  }
  //获取输入的关键字  并跳转到job页面
  getKeyWorld($event) {
    this.paramsData.keyword = $event;
    this._router.navigate(["/job/"], { queryParams: this.paramsData });
  }
  //或取到热门关键字 并跳转到job页面
  getHoutWord($event) {
    this.paramsData.keyword = $event.name;
    this._router.navigate(["/job/"], { queryParams: this.paramsData });
  }

  tabJCShowType(event) {
    this.typeCooper = event;
    this.getCooperData(); //获取合作企业高校
  }

  //获取合作企业高校
  getCooperData() {
    this._homeService.getCooperData(this.typeCooper).then(resp => {
      if (resp.success) {
        this.typeCooperList = resp["data"];
        // console.log(resp);
      }
    });
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/home/home.component.ts